import React from 'react'
import { useState } from "react";
import { FaCheck } from "react-icons/fa";
import styles from "./AIRecruiter.module.css";
import img1 from "../../Images/powerfulfeature1.png";
import img2 from "../../Images/powerfulfeature2.png";
import img3 from "../../Images/powerfulfeature3.png";
import img4 from "../../Images/powerfulfeature4.png";
import img5 from "../../Images/powerfulfeature5.png";
import visuals1 from "../../Images/talentsourcingimg2.png";
import visuals2 from "../../Images/talentsourcingimg3.png";
import visuals3 from "../../Images/talentsourcingimg4.png";
import visuals4 from "../../Images/talentsourcingimg5.png";
import visuals5 from "../../Images/talentsourcingimg6.png";
import heroImg from "../../Images/sourcingtalentimg.png"

function AIRecruiter() {
    const cards = [
        {
            title: "AI-powered candidate sourcing and screening",
            img: img1,
        },
        {
            title: "Resume parsing and ranking",
            img: img2,
        },
        {
            title: "Multi-platform search (LinkedIn, job portals, databases)",
            img: img3,
        },
        {
            title: "Automated candidate outreach via email & messaging",
            img: img4,
        },
        {
            title: "ATS & HRIS integration",
            img: img5,
        },
    ];
    const faqs = [
        {
            question: "Can AI parse all types of resumes?",
            answer: "Yes, ToxBox AI supports PDF, DOCX, and TXT formats.",
        },
        {
            question: "How does AI rank candidates?",
            answer: "Based on skills, experience, and role suitability.",
        },
        {
            question: "Does it integrate with ATS?",
            answer: "Yes, ToxBox AI connects with most major HR platforms.",
        },
        {
            question: "Is candidate data secure?",
            answer:
                "Absolutely. Data is encrypted and compliant with global standards.",
        },
        {
            question: "Can it reduce hiring bias?",
            answer:
                "Absolutely. Data is encrypted and compliant with global standards.",
        },
    ];
    const [activeStep, setActiveStep] = useState(1);

    const stepsData = {
        1: "1. Upload resumes in bulk (PDF, DOCX, TXT).",
        2: "2. AI parses resumes to extract skills, experience, education, and certifications.",
        3: "3. Candidates are scored and ranked based on your job requirements.",
        4: "4. Apply filters for role-specific needs, such as skills, experience, or location.",
        5: "5. Automatically shortlist the best candidates for interviews.",
    };

    const stepImages = {
        1: visuals1,
        2: visuals2,
        3: visuals3,
        4: visuals4,
        5: visuals5,
    };

    const [activeIndex, setActiveIndex] = useState(null);

    const toggleFAQ = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <div>
            <div className={styles.pageWrapper}>
                {/* HERO SECTION */}
                <section className={styles.heroSection}>
                    <h1>
                        AI Recruiter – Smart Talent <br />Sourcing <br /> <h6>with</h6>  <br /> <span>ToxBox AI</span>
                    </h1>
                    <p>
                        Find the right candidates instantly. Automate talent sourcing,<br /> screening, and outreach with AI-powered recruitment software.
                    </p>
                    <button className={styles.primaryBtn}>Start Smart Resume Screening</button>
                    <div className={styles.heroImage}></div>
                </section>


                {/* WHY CHOOSE SECTION */}
                <section className={styles.whyChoose}>
                    <h2>
                        Why Choose <span>ToxBox</span> AI for <br />Talent Sourcing?
                    </h2>
                    <br />
                    <p>ToxBox AI revolutionizes recruitment by streamlining candidate sourcing, <br />
                        reducing manual effort, and identifying top talent quickly. Save time, improve<br />
                        hiring quality, and scale recruitment efficiently.</p>

                    <div className={styles.cardContainer}>
                        <div className={styles.infoCard}>Save Time <p>Automate repetitive tasks and focus on what matters most, connecting with qualified candidates.</p></div>
                        <div className={styles.infoCard}>Improve Quality <p>Our AI powered matching ensures you see the most relevant candidates for your open roles</p></div>
                        <div className={styles.infoCard}>Scale efficiency <p>Effortlessly manage your talent pipeline, from sourcing to hiring, as your company grows.</p></div>
                    </div>
                </section>

                {/* HOW STREAMLINES SECTION */}


                <section className={styles.smartResume}>
                    <div className={styles.container}>

                        {/* LEFT SIDE — Dynamic Text */}
                        <div className={styles.textContent}>
                            <h2>
                                How AI Makes Resume <br /> Screening Smarter
                            </h2>

                            <p>
                                With ToxBox AI, every resume is evaluated consistently, helping
                                recruiters make data-driven hiring decisions without bias or delays.
                            </p>

                            <ul className={styles.steps}>
                                {Object.keys(stepsData).map((step) => (
                                    <li
                                        key={step}
                                        style={{
                                            fontWeight: Number(step) === activeStep ? "700" : "400",
                                            color: Number(step) === activeStep ? "#3c3c3c" : "#666",
                                            transform: Number(step) === activeStep ? "scale(1.05)" : "scale(1)",
                                            transition: "0.2s ease"
                                        }}
                                    >
                                        {stepsData[step]}
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* RIGHT SIDE — Steps + Image */}
                        <div>
                            <div className={styles.stepsRow}>
                                {[1, 2, 3, 4, 5].map((step) => (
                                    <React.Fragment key={step}>
                                        <div
                                            className={`${styles.stepCircle} ${activeStep === step ? styles.stepActive : ""
                                                }`}
                                            onClick={() => setActiveStep(step)}
                                        >
                                            {step === 1 ? "✔" : step}
                                        </div>

                                        {step !== 5 && <div className={styles.stepLine}></div>}
                                    </React.Fragment>
                                ))}
                            </div>

                            <div className={styles.visuals}>
                                <img
                                    src={stepImages[activeStep]}
                                    alt="Resume screening process"
                                />
                            </div>
                        </div>

                    </div>
                </section>

                {/* FEATURES SECTION */}
                <section className={styles.featuressection}>
                    <h2 className={styles.featureheading}>
                        Powerful Features of <span>ToxBox</span> <br /> AI Recruiter
                    </h2>
                    <p className={styles.featuresubtitle}>
                        Boost recruitment efficiency, reduce hiring time, and ensure you never
                        miss top talent <br />
                        with ToxBox AI.
                    </p>

                    <div className={styles.featuresgrid}>
                        {cards.map((card, index) => (
                            <div className={styles.featurecard} key={index}>
                                <img src={card.img} alt="" className={styles.featureimg} />
                                <p className={styles.featuretext}>{card.title}</p>
                            </div>
                        ))}
                    </div>
                </section>


                {/* WHY TOXBOXAI */}

                <section className={styles.section}>
                    <h4 className={styles.smallTitle}>ToxBox AI is perfect for</h4>
                    <h2 className={styles.mainTitle}>
                        Why HR Teams & Businesses Love <span>ToxBox AI</span>
                    </h2>

                    <div className={styles.grid}>

                        {/* CARD 1 — TALL VERTICAL */}
                        <div className={` ${styles.card1}`}>
                            <h3>Save time on manual candidate searches</h3>
                            <p>
                                Spend less time scrolling through endless <br />
                                resumes. ToxBox AI automates the
                                search <br />
                                process, surfacing only the most relevant<br />
                                profiles so your team can
                                focus on strategic<br /> tasks.
                            </p>
                            {/* <img src="../../Images/candidate serch 1.png" alt="card1" /> */}
                            <div className={styles.card1image}></div>

                        </div>

                        {/* RIGHT COLUMN */}
                        <div className={styles.rightCol}>

                            {/* CARD 2 */}
                            <div className={`${styles.card2}`}>
                                <div>
                                    <h3>Automate candidate outreach and follow-ups</h3>
                                    <p>
                                        No more missed opportunities. <br />
                                        ToxBox AI personalizes outreach and schedules<br />
                                        timely follow-ups for a consistent candidate <br /> experience.
                                    </p>
                                </div>
                                <div className={styles.card2image}></div>
                            </div>

                            {/* CARD 3 */}
                            <div className={`${styles.card3}`}>
                                <div>
                                    <h3>Improve hiring efficiency and reduce costs</h3>
                                    <p>
                                        Our AI matches candidates based on skills, experience,<br />
                                        and cultural fit. This ensures you connect with top <br />
                                        talent faster and make better hiring decisions.
                                    </p>
                                </div>
                                <div className={styles.card3image}></div>
                            </div>
                        </div>

                        {/* CARD 4 */}
                        <div className={`${styles.card4}`}>
                            <div>
                                <h3>Gain actionable insights through AI analytics</h3>
                                <p>
                                    Smart analytics reveal hiring trends, candidate<br />
                                    performance, and process bottlenecks. HR teams <br />
                                    get data-driven insights to continuously improve <br /> recruitment strategies.
                                </p>
                            </div>
                            <div className={styles.card4image}></div>
                        </div>

                        {/* CARD 5 */}
                        <div className={`${styles.card5}`}>
                            <div>
                                <h3>Identify the best-fit talent quickly</h3>
                                <p>
                                    Our AI matches candidates <br />
                                    based on skills, experience, and <br />
                                    cultural fit. This ensures you <br />
                                    connect with top talent faster <br />
                                    and make better hiring<br /> decisions.
                                </p>
                            </div>
                            <div className={styles.card5image}></div>
                        </div>

                    </div>
                </section>

                <section className={styles.hrsection}>
                    <div className={styles.left}>
                        <h1 className={styles.title}>Seamless ATS & HR<br />System Integration</h1>
                        <p className={styles.desc}>
                            ToxBox AI integrates with HR platforms like <br />
                            <span className={styles.bold}>
                                Workday, BambooHR, Greenhouse </span> and more.
                        </p>
                        <p className={styles.desc2}>
                            Automate sourcing, ranking, and outreach for a fully streamlined hiring process.
                        </p>
                        <button className={styles.button}>Integrate with Your HR System</button>
                    </div>


                    <div className={styles.right}>
                        <div className={styles.circleWrapper}>
                            {/* <img src="../../Images/hrsectionimg.png" alt="profile" className={styles.image} /> */}
                            <div className={styles.image}></div>
                        </div>
                    </div>
                </section>


                {/* testimonial Section */}
                <section className={styles.testimonialSection}>
                    <div className={styles.leftContent}>
                        <h2 className={styles.heading}>
                            Trusted by Recruiters <br /> Worldwide
                        </h2>
                        <p className={styles.subText}>
                            {/* Hear what our partners have to say about their success with{" "}
                            <span className={styles.highlight}>ToxBox AI</span> */}

                            See how ToxBox AI helps companies source top talent faster,<br />
                            reduce hiring bottlenecks, and improve candidate engagement.<br />
                            Join hundreds of satisfied HR professionals leveraging AI to <br />
                            optimize recruitment.
                        </p>
                    </div>

                    <div className={styles.card}>
                        <div className={styles.quoteIcon}>❝</div>
                        <p className={styles.review}>
                            Using AI for shortlisting has helped us find the <br />
                            best talent faster, improving our hiring quality <br />
                            significantly.
                        </p>

                        <div className={styles.cardFooter}>
                            <img
                                src="/images/user1.jpg"
                                alt="Savannah Nguyen"
                                className={styles.avatar}
                            />
                            <div>
                                <p className={styles.userName}>Savannah Nguyen</p>
                                <p className={styles.userRole}>HR Manager, Global Tech Firm</p>
                            </div>
                        </div>

                        <button className={styles.arrowBtn}>›</button>
                    </div>
                </section>

                {/* frequently asked questions section  */}
                <section className={styles.faqSection}>
                    <h2 className={styles.heading}>
                        Frequently Asked Questions About <br /> AI Resume Screening
                    </h2>

                    <div className={styles.faqList}>
                        {faqs.map((faq, index) => (
                            <div key={index} className={styles.faqItem}>
                                <div
                                    className={styles.faqQuestion}
                                    onClick={() => toggleFAQ(index)}
                                >
                                    <span>{faq.question}</span>
                                    <span className={styles.icon}>
                                        {activeIndex === index ? "−" : "+"}
                                    </span>
                                </div>
                                {activeIndex === index && (
                                    <p className={styles.faqAnswer}>{faq.answer}</p>
                                )}
                            </div>
                        ))}
                    </div>
                </section>

                {/* PRICING SECTION */}

                <section className={styles.pricingSection}>
                    <h2>Flexible Pricing for Every Recruitment Need</h2>
                    <p>Choose a plan tailored to your hiring volume. Start free or upgrade for unlimited AI <br />
                        sourcing, multi-channel outreach, and advanced analytics. ToxBox AI scales with your <br />
                        recruitment strategy.</p>
                    <div className={styles.pricingGrid}>

                        <div className={`${styles.card} ${styles.freeCard}`}>
                            <span className={styles.badgeFree}>Free</span>

                            <h3 className={styles.price}>
                                $0 <span>/ month</span>
                            </h3>

                            <button className={styles.currentBtn}>Current Plan</button>
                        </div>

                        <div className={`${styles.card} ${styles.premiumCard}`}>
                            <span className={styles.badgePremium}>Premium</span>

                            <div className={styles.checkMark}>
                                <FaCheck size={14} />
                            </div>

                            <h3 className={styles.price}>
                                $0 <span>/ month</span>
                            </h3>

                            <ul className={styles.features}>
                                <li><FaCheck /> Unlimited resume screening</li>
                                <li><FaCheck /> Advanced analytics</li>
                                <li><FaCheck /> Multi-channel integration</li>
                                <li><FaCheck /> Enterprise-grade security</li>
                            </ul>

                            <button className={styles.upgradeBtn}>Upgrade</button>
                        </div>
                    </div>
                </section>


                {/* CTA SECTION */}
                <section className={styles.talentSection}>
                    <div className={styles.container}>

                        {/* Left Image */}
                        <div className={styles.left}>
                            <img src={heroImg} alt="AI Talent Sourcing Illustration" />
                        </div>

                        {/* Right Content */}
                        <div className={styles.right}>
                            <h2>Start Sourcing Top Talent<br />Smarter with AI</h2>

                            <p>
                                Stop wasting time on manual recruitment. Let ToxBox AI automate talent
                                sourcing, <br />
                                screening, and outreach so you can hire the best candidates efficiently.
                            </p>

                            <button className={styles.btn}>Get Started Now</button>
                        </div>

                    </div>
                </section>
            </div >
        </div >
    )
}

export default AIRecruiter
